import { CUSTOM_ELEMENTS_SCHEMA, InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ButtonDropdownModule,
  ButtonModule,
  CardModule,
  FormElementsModule,
  ModalDialogLayoutModule,
  PagingControlModule,
} from '@lib/ui';
import { BarRatingModule } from 'ngx-bar-rating';
import { ListItemsService, ListItemsTableModule } from '@modules';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NotificationsModule } from '@lib/notifications';
import { ModalStartAppointmentComponent } from './start-appointment-modal.component';
import { TranslateModule } from '@project/translate';

export const UNIT_SELECTION_SERVICE_TOKEN = new InjectionToken('List of Units');

@NgModule({
  declarations: [ModalStartAppointmentComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ModalDialogLayoutModule,
    FormElementsModule,
    ButtonModule,
    BarRatingModule,
    CardModule,
    ListItemsTableModule,
    ButtonDropdownModule,
    NotificationsModule,
    PagingControlModule,
    MatProgressSpinnerModule,
  ],
  exports: [ModalStartAppointmentComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: UNIT_SELECTION_SERVICE_TOKEN,
      useClass: ListItemsService,
    },
  ],
})
export class ModalStartAppointmentModule {}
